import React from 'react';
import styled from 'styled-components';
import { clamp } from 'ramda';

import { colors, neumorphism } from '../constant';
import { respondTo } from '../responsive';


const HpBar = ({ className, value, total }) => {
    const haveTime = (value != undefined && total != undefined);
    return (
        <Root className={className}>
            <Label>{ haveTime ? '可用時數' : '已用時數' }</Label>
            { haveTime && <Bar value={total - value} total={total}/> }
            { haveTime && <Text>{`${Math.round(total - value) || '-'} / ${Math.round(total) || '-'} 小時`}</Text> }
            { !haveTime && <Text>{`${value} 小時`}</Text>}
        </Root>
    )
}

const Root = styled.div`
    display: flex;
    align-items: center;

    ${ respondTo.lg } {
        width: 100%;
        margin-top: 24px;
        justify-content: flex-end;
        align-items: flex-end;
    }

    ${ respondTo.md } {
        margin-top: 8px;
        flex-direction: column;
    }
`

const Label = styled.span`
    font-size: 12px;
    color: ${ colors.label2 };
    margin-right: 16px;
    line-height: 1em;

    ${ respondTo.md } {
        display: none;
    }
`

const Text = styled.span`
    font-size: 14px;
    font-weight: bold;
    color: ${ colors.text };
    line-height: 1em;

    ${ respondTo.lg } {
        margin-top: 8px;
    }
    
    ${ respondTo.md } {
        font-size: 12px;
    }
`

const Bar = styled.span`
    display: inline-block;
    width: 240px;
    height: 16px;
    position: relative;
    border-radius: 50em;
    ${ neumorphism.concave };
    background-color: #f1f1f1;
    margin-right: 16px;

    &::before {
        content: ' ';
        display: block;
        width: ${({value, total}) => clamp(0, 1, value / total) * 100}%;
        height: calc(100% - 4px);
        margin: 2px;
        border-radius: 50em;
        background-color: ${ ({value, total}) => {
            const hp = clamp(0, 1, value / total);
            return hp > 0.4 ? colors.statusGreat :
                   hp > 0.15 ? colors.statusWarn : 
                              colors.statusDanger
        }};
    }

    ${ respondTo.md } {
        width: 100%;
        margin-right: 0;
    }
` 

export default HpBar;
